export default __webpack_public_path__ + "static/media/colorfulruglivingroom.9740fe17.jpg";